import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const aiInLineControlTableColumns: ITableColumn[] = [
  {
    labelPath: 'aiInLineControlPage.tableColumns.ruleName',
    propertyKey: 'ruleName',
    colType: TableColumnTypeEnum.TextWithIcon,
    width: 490,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'ruleName',
    iconSrc: 'aiServiceIcon',
  },
  {
    labelPath: 'aiInLineControlPage.tableColumns.ruleId',
    propertyKey: 'ruleId',
    colType: TableColumnTypeEnum.CopyableText,
    width: 150,
    widthType: WidthType.Pixel,
    withCopyIcon: true,
    iconOnly: false,
    isSortable: true,
    sortKey: 'ruleId',
  },
  {
    labelPath: 'aiInLineControlPage.tableColumns.preventionType',
    propertyKey: 'preventionType',
    colType: TableColumnTypeEnum.TextWithIcon,
    width: 160,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'preventionType',
    iconSrc: 'preventionTypeIcon',
    toCapitalize: true,
  },
  {
    labelPath: 'aiInLineControlPage.tableColumns.timestamp',
    propertyKey: 'timestamp',
    colType: TableColumnTypeEnum.Text,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'timestamp',
  },
  {
    labelPath: 'aiInLineControlPage.tableColumns.agentId',
    propertyKey: 'agentId',
    colType: TableColumnTypeEnum.CopyableText,
    width: 92,
    widthType: WidthType.Pixel,
    withCopyIcon: true,
    iconOnly: true,
    isSortable: false,
  },
  {
    labelPath: 'aiInLineControlPage.tableColumns.actor',
    propertyKey: 'actor',
    colType: TableColumnTypeEnum.CopyableText,
    width: 92,
    widthType: WidthType.Pixel,
    withCopyIcon: true,
    iconOnly: true,
    isSortable: false,
  },
  {
    labelPath: 'aiInLineControlPage.tableColumns.threadId',
    propertyKey: 'threadId',
    colType: TableColumnTypeEnum.CopyableText,
    width: 92,
    widthType: WidthType.Pixel,
    withCopyIcon: true,
    iconOnly: true,
    isSortable: false,
  },
  {
    labelPath: 'aiInLineControlPage.tableColumns.environmentId',
    propertyKey: 'environmentId',
    colType: TableColumnTypeEnum.CopyableText,
    width: 120,
    widthType: WidthType.Pixel,
    withCopyIcon: true,
    iconOnly: true,
    isSortable: false,
  },
];
